import * as React from "react";
import { Layout } from "../components/Layout";

const HygieneTemplate = ({ data, children }) => {
  return (
    <Layout
      metaTitle={data.data.meta_title}
      metaDescription={data.data.meta_description}
    >
      <div className="h-6 md:h-10 bg-teal-alpha-30 mb-6 md:mb-10"></div>

      <div className="hygiene-page container text-base">
        <div className="xl:w-8/12 2xl:w-7/12">{children}</div>
      </div>

      <div className="h-6 md:h-10 bg-teal-alpha-30 mt-6 md:mt-10"></div>
    </Layout>
  );
};

export default HygieneTemplate;
